import { DownloadIcon, Flex, Text } from "@fluentui/react-northstar";
import styled from "styled-components";
import AllDocument from "../components/content/AllDocument";
import CellCategory from "../components/CellsContent/CellCategory";
import CellDate from "../components/CellsContent/CellDate";
import CellFullnameAvatar from "../components/CellsContent/CellFullnameAvatar";
import CellName from "../components/CellsContent/CellName";
import CellMore from "../components/CellsContent/CellMore";
import CellHeaderName from "../components/CellsContent/CellHeaderName";
import EmptyFolder from "../components/empty/EmptyFolder";
import CellHeaderDate from "../components/CellsContent/CellHeaderDate";
import CellLeave from "../components/CellsContent/CellLeave";
import { toast } from "sonner";
import { TOAST_DONWLOADING_DOCUMENT } from "../hooks/useLogicDocumentsHr";
import CellExpenseClient from "../components/CellsContent/CellExpenseClient";
import { checkIfWithinMinutes } from "../../../utils/dates";
import moment from "moment";

export const AllDocuments = ({ activeTab, all_documents = [], refetch }) => {
    return (
        <Flex column fill>
            <RightTitle>{_str_capitalize(activeTab?.name)}</RightTitle>
            <AllDocument
                documents={all_documents}
                locked={!activeTab?.update_authorized}
                refetch={refetch}
            />
        </Flex>
    );
};

export const _str_capitalize = (string = " ") => {
    return string.at(0).toUpperCase() + string.slice(1);
};

export const func_get_table_data = (
    data,
    styles_cells,
    handleDoubleClickRow,
    handleClickRow,
    handleCheckAll,
    handleClickDownloadFolder = () => null,
    sorting = "asc"
) => {
    // headers item
    const header_items = [
        {
            content: (
                <CellHeaderName onCheckAll={handleCheckAll} canSort={true} />
            ),
            key: "name",
            styles: styles_cells.name,
        },
        {
            content: "Collaborateur",
            key: "employee",
            styles: styles_cells.employee,
        },
    ];
    // rows
    const showCategory = data.contents.some((content) => content.category_name);
    const showDate = data.contents.some((content) => content.created_at);

    header_items.push({
        content: showCategory ? "Catégorie" : "",
        key: "category",
        styles: styles_cells.category,
    });

    header_items.push({
        content: showDate ? "Date d'ajout" : "",
        key: "added_date",
        styles: styles_cells.date_added,
    });

    const rows = data.contents
        .sort((a, b) =>
            sorting === "asc"
                ? a.name.localeCompare(b.name)
                : b.name.localeCompare(a.name)
        )
        .map((content) => {
            const created_at = content.created_at;
            const format_created_at = created_at
                ? moment(created_at).format("DD/MM/YYYY")
                : "";
            const isRecent = checkIfWithinMinutes(created_at);
            return {
                key: content.id,
                onDoubleClick: () =>
                    handleDoubleClickRow(
                        content.id,
                        content.is_folder,
                        content?.document_type
                    ),
                onClick: () => handleClickRow(content.id),
                checked: content.checked,
                is_folder: content.is_folder,
                "data-recent": isRecent ? "recent" : "",
                items: [
                    {
                        content: (
                            <CellName
                                name={content.name ?? ""}
                                isFolder={content.is_folder}
                                isEmployeeFolder={content.user?.id}
                                onClickName={() =>
                                    handleDoubleClickRow(
                                        content.id,
                                        content.is_folder,
                                        content?.document_type
                                    )
                                }
                            />
                        ),
                        key: `${content.id}-1`,
                        styles: styles_cells.name,
                        truncateContent: true,
                        checked: content.checked ?? false,
                    },
                    {
                        content: (
                            <CellFullnameAvatar
                                fullname={content.user.name}
                                avatar={content.user.avatar}
                            />
                        ),
                        key: `${content.id}-2`,
                        truncateContent: true,
                        styles: styles_cells.employee,
                    },
                    {
                        content: (
                            <CellCategory
                                category_name={content?.category_name ?? ""}
                            />
                        ),
                        key: `${content.id}-3`,
                        truncateContent: true,
                        styles: styles_cells.category,
                    },
                    {
                        content: <CellDate date={format_created_at} />,
                        key: `${content.id}-4`,
                        truncateContent: true,
                        styles: styles_cells.date_added,
                    },
                    {
                        content: content.is_folder ? (
                            <DownloadIcon
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleClickDownloadFolder(content.id);
                                    toast.loading(
                                        "Téléchargement en cours ...",
                                        {
                                            id: TOAST_DONWLOADING_DOCUMENT,
                                        }
                                    );
                                }}
                            /> // download folders
                        ) : (
                            <div>
                                <CellMore document_id={content.id} />
                            </div>
                        ),
                        key: `${content.id}-5`,
                        truncateContent: true,
                        styles: styles_cells.button_more,
                    },
                ],
            };
        });

    // init empty row
    const empty_row = {
        key: "empty_row",
        styles: {
            border: 0,
        },
        items: [
            {
                content: <EmptyFolder />,
                key: "empty_folder",
                className: "empty_folder",
                styles: {
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px",
                    height: "100%",
                    backgroundColor: "white!important",
                    cursor: "auto",
                    "&:hover": {
                        backgroundColor: "white!important",
                        cursor: "auto",
                    },
                },
            },
        ],
    };

    const headers = {
        key: "header",
        items: [
            ...header_items,
            {
                content: "",
                key: "button_action",
                styles: styles_cells.button_more,
            },
        ],
    };

    return {
        header_format: headers,
        breadcrumb_format: data.breadcrumbs,
        rows_format: rows.length > 0 ? rows : [empty_row],
    };
};

export const func_get_table_data_timesheet = (
    data,
    styles_cells,
    handleDoubleClickRow,
    handleClickRow,
    handleCheckAll,
    handleClickDownloadFolder = () => null,
    handleClickDownloadFile = () => null,
    sorting = "asc"
) => {
    // headers item
    const header_items = [
        {
            content: (
                <CellHeaderName onCheckAll={handleCheckAll} canSort={true} />
            ),
            key: "name",
            styles: styles_cells.name,
        },
    ];
    // rows
    const showEmployee = data.contents.some((content) => content.user?.id);
    const showApprovalDate = data.contents.some(
        (content) => content.approval_date
    );

    header_items.push({
        content: showEmployee ? "Collaborateur" : "",
        key: "employee",
        styles: styles_cells.employee,
    });

    header_items.push({
        content: showApprovalDate ? "Date de validation" : "",
        key: "validation_date",
        styles: styles_cells.date_added,
    });

    const rows = data.contents
        .sort((a, b) =>
            sorting === "asc"
                ? a.name.toString().localeCompare(b.name)
                : b.name.toString().localeCompare(a.name)
        )
        .map((content) => {
            const isRecent = checkIfWithinMinutes(content.created_at);
            return {
                key: content.id,
                onDoubleClick: () =>
                    handleDoubleClickRow({
                        row_id: content.id,
                        is_folder: content.is_folder,
                        name: content?.name,
                        document_type: content?.document_type,
                    }),
                onClick: () => handleClickRow(content.id),
                checked: content.checked,
                is_folder: content.is_folder,
                "data-recent": isRecent ? "recent" : "",
                items: [
                    {
                        content: (
                            <CellName
                                name={content.name ?? ""}
                                isFolder={content.is_folder}
                                isEmployeeFolder={content.user?.id}
                                onClickName={() =>
                                    handleDoubleClickRow({
                                        row_id: content.id,
                                        is_folder: content.is_folder,
                                        name: content?.name,
                                        document_type: content?.document_type,
                                    })
                                }
                            />
                        ),
                        key: `${content.id}-1`,
                        styles: styles_cells.name,
                        truncateContent: true,
                        checked: content.checked ?? false,
                    },
                    {
                        content: (
                            <CellFullnameAvatar
                                fullname={content.user.name}
                                avatar={content.user.avatar}
                            />
                        ),
                        key: `${content.id}-2`,
                        truncateContent: true,
                        styles: styles_cells.employee,
                    },
                    {
                        content: <CellDate date={content?.approval_date} />,
                        key: `${content.id}-4`,
                        truncateContent: true,
                        styles: styles_cells.date_added,
                    },
                    {
                        content: content.is_folder ? (
                            <DownloadIcon
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleClickDownloadFolder({
                                        folder_id: content.id,
                                    });
                                    toast.loading(
                                        "Téléchargement en cours ...",
                                        {
                                            id: TOAST_DONWLOADING_DOCUMENT,
                                        }
                                    );
                                }}
                            /> // download folders
                        ) : (
                            <DownloadIcon
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleClickDownloadFile({
                                        file_id: content.id,
                                        document_type: content?.document_type,
                                    });
                                    toast.loading(
                                        "Téléchargement en cours ...",
                                        {
                                            id: TOAST_DONWLOADING_DOCUMENT,
                                        }
                                    );
                                }}
                            />
                        ),
                        key: `${content.id}-5`,
                        truncateContent: true,
                        styles: styles_cells.button_more,
                    },
                ],
            };
        });

    // init empty row
    const empty_row = {
        key: "empty_row",
        styles: {
            border: 0,
        },
        items: [
            {
                content: <EmptyFolder />,
                key: "empty_folder",
                className: "empty_folder",
                styles: {
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px",
                    height: "100%",
                    backgroundColor: "white!important",
                    cursor: "auto",
                    "&:hover": {
                        backgroundColor: "white!important",
                        cursor: "auto",
                    },
                },
            },
        ],
    };

    const headers = {
        key: "header",
        items: [
            ...header_items,
            {
                content: "",
                key: "button_action",
                styles: styles_cells.button_more,
            },
        ],
    };

    return {
        header_format: headers,
        breadcrumb_format: data.breadcrumbs,
        rows_format: rows.length > 0 ? rows : [empty_row],
    };
};

export const func_get_table_data_common = (
    data,
    styles_cells,
    handleDoubleClickRow,
    handleClickRow,
    handleCheckAll,
    handleClickDownloadFolder = () => null,
    sorting = "asc"
) => {
    // headers item
    const header_items = [
        {
            content: <CellHeaderName onCheckAll={handleCheckAll} />,
            key: "name",
            styles: styles_cells.name,
        },
    ];
    // rows
    const showEmployee = data.contents.some((content) => content.user?.id);
    const showDate = data.contents.some((content) => content.created_at);

    header_items.push({
        content: showEmployee ? "Ajouté par" : "",
        key: "employee",
        styles: styles_cells.employee,
    });

    header_items.push({
        content: showDate ? (
            <CellHeaderDate title="Date d'ajout" canSort={true} />
        ) : (
            ""
        ),
        key: "date",
        styles: styles_cells.date_added,
    });

    const rows = data.contents
        .sort((a, b) =>
            sorting === "asc"
                ? new Date(b.created_at) - new Date(a.created_at)
                : new Date(a.created_at) - new Date(b.created_at)
        )
        .map((content) => {
            const created_at = content.created_at;
            const format_created_at = moment(created_at).format("DD/MM/YYYY");
            const isRecent = checkIfWithinMinutes(created_at);
            return {
                key: content.id,
                onDoubleClick: () => {
                    return handleDoubleClickRow({
                        row_id: content.id,
                        is_folder: content.is_folder,
                        name: content?.name,
                        document_type: content?.document_type,
                    });
                },
                onClick: () => handleClickRow(content.id),
                checked: content.checked,
                is_folder: content.is_folder,
                "data-recent": isRecent ? "recent" : "",
                items: [
                    {
                        content: (
                            <CellName
                                name={content.name ?? ""}
                                isFolder={content.is_folder}
                                isEmployeeFolder={content.user?.id}
                                onClickName={() =>
                                    handleDoubleClickRow({
                                        row_id: content.id,
                                        is_folder: content.is_folder,
                                        name: content?.name,
                                        document_type: content?.document_type,
                                    })
                                }
                            />
                        ),
                        key: `${content.id}-1`,
                        styles: styles_cells.name,
                        truncateContent: true,
                        checked: content.checked ?? false,
                    },
                    {
                        content: (
                            <CellFullnameAvatar
                                fullname={content.user.name}
                                avatar={content.user.avatar}
                            />
                        ),
                        key: `${content.id}-2`,
                        truncateContent: true,
                        styles: styles_cells.employee,
                    },
                    {
                        content: <CellDate date={format_created_at} />,
                        key: `${content.id}-4`,
                        truncateContent: true,
                        styles: styles_cells.date_added,
                    },
                    {
                        content: content.is_folder ? (
                            <DownloadIcon
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleClickDownloadFolder(content.id);
                                    toast.loading(
                                        "Téléchargement en cours ...",
                                        {
                                            id: TOAST_DONWLOADING_DOCUMENT,
                                        }
                                    );
                                }}
                            /> // download folders
                        ) : (
                            <CellMore document_id={content.id} />
                        ),
                        key: `${content.id}-5`,
                        truncateContent: true,
                        styles: styles_cells.button_more,
                    },
                ],
            };
        });

    // init empty row
    const empty_row = {
        key: "empty_row",
        styles: {
            border: 0,
        },
        items: [
            {
                content: <EmptyFolder />,
                key: "empty_folder",
                className: "empty_folder",
                styles: {
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px",
                    height: "100%",
                    backgroundColor: "white!important",
                    cursor: "auto",
                    "&:hover": {
                        backgroundColor: "white!important",
                        cursor: "auto",
                    },
                },
            },
        ],
    };

    const headers = {
        key: "header",
        items: [
            ...header_items,
            {
                content: "",
                key: "button_action",
                styles: styles_cells.button_more,
            },
        ],
    };

    return {
        header_format: headers,
        breadcrumb_format: data.breadcrumbs,
        rows_format: rows.length > 0 ? rows : [empty_row],
    };
};

export const func_get_table_data_leave = (
    data,
    styles_cells,
    handleDoubleClickRow,
    handleClickRow,
    handleCheckAll,
    handleClickDownloadFolder = () => null,
    handleClickDownloadFile = () => null,
    sorting = "asc"
) => {
    // headers item
    const header_items = [
        {
            content: (
                <CellHeaderName onCheckAll={handleCheckAll} canSort={true} />
            ),
            key: "name",
            styles: styles_cells.name,
        },
    ];
    // rows
    const showEmployee = data.contents.some((content) => content.user?.id);
    const showTypeLeave = data.contents.some(
        (content) => content?.leave_details?.name
    );
    const showDate = data.contents.some((content) => content.created_at);

    header_items.push({
        content: showEmployee ? "Collaborateur" : "",
        key: "employee",
        styles: styles_cells.employee,
    });

    header_items.push({
        content: showTypeLeave ? "Type d'absence" : "",
        key: "leave_type",
        styles: styles_cells.category,
    });

    header_items.push({
        content: showDate ? "Date de début" : "",
        key: "start_date",
        styles: styles_cells.date_added,
    });

    const rows = data.contents
        ?.sort((a, b) => {
            return sorting === "asc"
                ? a.name.toString().localeCompare(b.name)
                : b.name.toString().localeCompare(a.name);
        })
        .map((content) => {
            const format_created_at = content.created_at
                ? moment(content.created_at).format("DD/MM/YYYY")
                : "";
            const isRecent = checkIfWithinMinutes(content.created_at);
            return {
                key: content.id,
                onDoubleClick: () =>
                    handleDoubleClickRow({
                        row_id: content.id,
                        is_folder: content.is_folder,
                        name: content?.name,
                        document_type: content?.document_type,
                    }),
                onClick: () => handleClickRow(content.id),
                checked: content.checked,
                is_folder: content.is_folder,
                "data-recent": isRecent ? "recent" : "",
                items: [
                    {
                        content: (
                            <CellName
                                name={content.name ?? ""}
                                isFolder={content.is_folder}
                                isEmployeeFolder={content.user?.id}
                                onClickName={() =>
                                    handleDoubleClickRow({
                                        row_id: content.id,
                                        is_folder: content.is_folder,
                                        name: content?.name,
                                        document_type: content?.document_type,
                                    })
                                }
                            />
                        ),
                        key: `${content.id}-1`,
                        styles: styles_cells.name,
                        truncateContent: true,
                        checked: content.checked ?? false,
                    },
                    {
                        content: (
                            <CellFullnameAvatar
                                fullname={content.user.name}
                                avatar={content.user.avatar}
                            />
                        ),
                        key: `${content.id}-2`,
                        truncateContent: true,
                        styles: styles_cells.employee,
                    },
                    {
                        content: (
                            <CellLeave
                                color={content?.leave_details?.color}
                                name={content?.leave_details?.name}
                            />
                        ),
                        key: `${content.id}-3`,
                        truncateContent: true,
                        styles: styles_cells.category,
                    },
                    {
                        content: <CellDate date={format_created_at} />,
                        key: `${content.id}-4`,
                        truncateContent: true,
                        styles: styles_cells.date_added,
                    },
                    {
                        content: content.is_folder ? (
                            <DownloadIcon
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleClickDownloadFolder(content.id);
                                    toast.loading(
                                        "Téléchargement en cours ...",
                                        {
                                            id: TOAST_DONWLOADING_DOCUMENT,
                                        }
                                    );
                                }}
                            /> // download folders
                        ) : (
                            <DownloadIcon
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleClickDownloadFile({
                                        file_id: content.id,
                                        document_type: content?.document_type,
                                    });
                                    toast.loading(
                                        "Téléchargement en cours ...",
                                        {
                                            id: TOAST_DONWLOADING_DOCUMENT,
                                        }
                                    );
                                }}
                            />
                        ),
                        key: `${content.id}-5`,
                        truncateContent: true,
                        styles: styles_cells.button_more,
                    },
                ],
            };
        });

    // init empty row
    const empty_row = {
        key: "empty_row",
        styles: {
            border: 0,
        },
        items: [
            {
                content: <EmptyFolder />,
                key: "empty_folder",
                className: "empty_folder",
                styles: {
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px",
                    height: "100%",
                    backgroundColor: "white!important",
                    cursor: "auto",
                    "&:hover": {
                        backgroundColor: "white!important",
                        cursor: "auto",
                    },
                },
            },
        ],
    };

    const headers = {
        key: "header",
        items: [
            ...header_items,
            {
                content: "",
                key: "button_action",
                styles: styles_cells.button_more,
            },
        ],
    };

    return {
        header_format: headers,
        breadcrumb_format: data.breadcrumbs,
        rows_format: rows.length > 0 ? rows : [empty_row],
    };
};

export const func_get_table_data_expenses = (
    data,
    styles_cells,
    handleDoubleClickRow,
    handleClickRow,
    handleCheckAll,
    handleClickDownloadFolder = () => null,
    handleClickDownloadFile = () => null,
    sorting = "asc"
) => {
    // headers item
    const header_items = [
        {
            content: (
                <CellHeaderName onCheckAll={handleCheckAll} canSort={true} />
            ),
            key: "name",
            styles: styles_cells.name,
        },
    ];
    // rows
    const showEmployee = data?.contents.some((content) => content.user?.id);
    const showClient = data?.contents.some((content) => content.client_name);
    const showCode = data?.contents.some((content) => content.object_code);

    header_items.push({
        content: showEmployee ? "Collaborateur" : "",
        key: "employee",
        styles: styles_cells.employee,
    });

    header_items.push({
        content: showClient ? "Client" : "",
        key: "client",
        styles: styles_cells.category,
    });

    header_items.push({
        content: showCode ? "Code Budgétaire" : "",
        key: "object_code",
        styles: styles_cells.date_added,
    });

    const rows = data?.contents
        ?.sort((a, b) => {
            return sorting === "asc"
                ? a.name.toString().localeCompare(b.name)
                : b.name.toString().localeCompare(a.name);
        })
        .map((content) => {
            const isRecent = checkIfWithinMinutes(content.created_at);
            return {
                key: content.id,
                onDoubleClick: () => {
                    handleDoubleClickRow({
                        row_id: content?.id,
                        is_folder: content?.is_folder,
                        name: content?.name,
                        document_type: content?.document_type,
                    });
                    return;
                },
                onClick: () => handleClickRow(content.id),
                checked: content.checked,
                is_folder: content.is_folder,
                "data-recent": isRecent ? "recent" : "",
                items: [
                    {
                        content: (
                            <CellName
                                name={content.name ?? ""}
                                isFolder={content.is_folder}
                                isEmployeeFolder={content.user?.id}
                                onClickName={() =>
                                    handleDoubleClickRow({
                                        row_id: content?.id,
                                        is_folder: content?.is_folder,
                                        name: content?.name,
                                        document_type: content?.document_type,
                                    })
                                }
                            />
                        ),
                        key: `${content.id}-1`,
                        styles: styles_cells.name,
                        truncateContent: true,
                        checked: content.checked ?? false,
                    },
                    {
                        content: (
                            <CellFullnameAvatar
                                fullname={content.user.name}
                                avatar={content.user.avatar}
                            />
                        ),
                        key: `${content.id}-2`,
                        truncateContent: true,
                        styles: styles_cells.employee,
                    },
                    {
                        content: (
                            <CellExpenseClient client={content?.client_name} />
                        ),
                        key: `${content.id}-3`,
                        truncateContent: true,
                        styles: styles_cells.category,
                    },
                    {
                        content: (
                            <CellCategory
                                category_name={content?.object_code}
                            />
                        ),
                        key: `${content.id}-4`,
                        truncateContent: true,
                        styles: styles_cells.date_added,
                    },
                    {
                        content: content.is_folder ? (
                            <DownloadIcon
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleClickDownloadFolder(content.id);
                                    toast.loading(
                                        "Téléchargement en cours ...",
                                        {
                                            id: TOAST_DONWLOADING_DOCUMENT,
                                        }
                                    );
                                }}
                            /> // download folders
                        ) : (
                            <DownloadIcon
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleClickDownloadFile({
                                        file_id: content.id,
                                        document_type: content?.document_type,
                                    });
                                    toast.loading(
                                        "Téléchargement en cours ...",
                                        {
                                            id: TOAST_DONWLOADING_DOCUMENT,
                                        }
                                    );
                                }}
                            />
                        ),
                        key: `${content.id}-5`,
                        truncateContent: true,
                        styles: styles_cells.button_more,
                    },
                ],
            };
        });

    // init empty row
    const empty_row = {
        key: "empty_row",
        styles: {
            border: 0,
        },
        items: [
            {
                content: <EmptyFolder />,
                key: "empty_folder",
                className: "empty_folder",
                styles: {
                    flex: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px",
                    height: "100%",
                    backgroundColor: "white!important",
                    cursor: "auto",
                    "&:hover": {
                        backgroundColor: "white!important",
                        cursor: "auto",
                    },
                },
            },
        ],
    };

    const headers = {
        key: "header",
        items: [
            ...header_items,
            {
                content: "",
                key: "button_action",
                styles: styles_cells.button_more,
            },
        ],
    };

    return {
        header_format: headers,
        breadcrumb_format: data.breadcrumbs,
        rows_format: rows.length > 0 ? rows : [empty_row],
    };
};

const RightTitle = styled(Text)`
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    color: #242424;
`;
